module.exports = __webpack_public_path__ + "img/briefcase.793eed18.svg";